import { ExportToCsv } from "export-to-csv";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { csvMappingRechargeSales } from "../../../../utils/common/csvMappings/rechargeSales";
import {
  billedFilter,
  getJCJPIDs,
  lmtdCheck,
  onBoardedFilter,
} from "../../../../utils/common/index";
//import { CustomCard } from "../../../../../components/customCard/index";
import Spinner from "../../../../components/presentationals/Spinner";
import Error from "../../../../components/Error/index";
import {
  fetchShowAlertRecharge,
  hideAlertRecharge,
} from "../../../../redux/actions/rechargeSalesAction";

import RechargesalesDistrbution from "../../../../views/rechargeSales/distribution/index";

export const RechargeDistributionTabs = (props) => {
  const dispatch = useDispatch();
  const { distributionObj, rechCsvLoading } = useSelector(
    (state) => state.rechargeSalesReducer
  );

  let {
    url,
    csvEndPointUrl,
    isCsvActive,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    triggerFetchRechargeDistribution,
    triggerRechargeDistributionCsv,
    moduleName,
    section,
  } = props;
  const endpointData = distributionObj && distributionObj.distributionTableData;
  const tableContainedData =
    endpointData && endpointData[url] && endpointData[url][0];
  let { level, jioPointId, partnerRT, id } = getJCJPIDs(filterValue);
  const data = {
    id: id,
    partnerRoleType: partnerRT,
    fromDate: headerSelectedDateFrom,
    toDate: headerSelectedDateTo,
    section: props.section,
    moduleName: props.moduleName,
    level: level,
    jioPointId: jioPointId,
  };

  useEffect(() => {
    function fetchData() {
      const obj = {
        headers: {
          "Content-Type": "application/json",
          url: url,
        },
        params: data,
        extraData: url,
      };

      return dispatch(triggerFetchRechargeDistribution(obj));
    }
    if (
      distributionObj &&
      distributionObj.distributionTableData[url] === undefined
    ) {
      fetchData();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    triggerFetchRechargeDistribution,
    headerSelectedDateFrom,
    headerSelectedDateTo,
  ]);

  function fetchCsvData(tab) {
    let tabName = "";
    if (tab === "Billed") {
      // setDownloadBilledCsv(true);
      tabName = "billed";
    } else {
      // setDownloadBoardedCsv(true);
      tabName = "onboard";
    }
    const obj = {
      headers: {
        "Content-Type": "application/json",
        url: csvEndPointUrl,
      },
      params: {
        ...data,
        dist: tabName,
      },
      extraData: csvEndPointUrl,
      tab,
    };
    let options = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: false,
      filename: "RechargeSales_distribution",
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };

    let csvExporter = new ExportToCsv(options);
    return dispatch(
      triggerRechargeDistributionCsv(obj, (response, params) => {
        if (response?.content?.length) {
          let csvData;
          csvData = csvMappingRechargeSales({
            partnerRole:
              filterValue.selectedJC === ""
                ? filterValue.selectedPartnerRoleName
                : filterValue.selectedJC === "ALL"
                ? filterValue.selectedPartnerRoleName
                : "JP",
            data: response.content,
            option: params.dist,
            tileName: props.data.tileName.toUpperCase(),
            section: "distribution",
          });
          // if (params.dist === "billed") {
          //   csvData = billedFilter(response.content, "recharge");
          // } else {
          //   csvData = onBoardedFilter(response.content, "recharge");
          // }
          csvExporter.generateCsv(csvData);
        } else {
          dispatch(fetchShowAlertRecharge());
          setTimeout(() => {
            dispatch(hideAlertRecharge());
          }, 5000);
        }
      })
    );
  }
  return (
    <>
      {distributionObj.loading ? (
        <Spinner />
      ) : tableContainedData ? (
        <>
          <RechargesalesDistrbution
            filterValue={filterValue}
            tableContainedData={tableContainedData}
            fetchCsvData={fetchCsvData}
            url={url}
            csvEndPointUrl={csvEndPointUrl}
            isCsvActive={isCsvActive}
            rechCsvLoading={rechCsvLoading}
            moduleName={moduleName}
            section={section}
            headerSelectedDateFrom={headerSelectedDateFrom}
            headerSelectedDateTo={headerSelectedDateTo}
          />
        </>
      ) : (
        <Error error={distributionObj.error} />
      )}
    </>
  );
};

RechargeDistributionTabs.propTypes = {
  url: PropTypes.string,
  csvEndPointUrl: PropTypes.string,
  isCsvActive: PropTypes.string,
  filterValue: PropTypes.object,
  headerSelectedDateFrom: PropTypes.string,
  headerSelectedDateTo: PropTypes.string,
  triggerSimActivationAPI: PropTypes.func,
  triggerSimActivationCsvAPI: PropTypes.func,
};
